/** Copy unificado de estados contables (backend → UI). */

const PERIOD: Record<string, string> = {
  OPEN: 'Abierto',
  CLOSED: 'Cerrado',
  LOCKED: 'Bloqueado',
  MISSING: 'Sin período',
};

const JOURNAL: Record<string, string> = {
  DRAFT: 'Borrador',
  POSTED: 'Contabilizado',
  REVERSED: 'Revertido',
};

const PROCESS: Record<string, string> = {
  DRAFT: 'Borrador',
  UPLOADED: 'Borrador',
  CALCULATED: 'Calculado',
  VALIDATED: 'Calculado',
  POSTED: 'Contabilizado',
  COMPLETED: 'Contabilizado',
  REVERSED: 'Revertido',
  FAILED: 'Fallido',
  INVALID: 'Fallido',
  VALIDATING: 'Procesando',
  PROCESSING: 'Procesando',
};

export function periodStatusLabel(status?: string | null): string {
  if (!status) return '—';
  return PERIOD[status] ?? status;
}

export function journalStatusLabel(status?: string | null): string {
  if (!status) return '—';
  return JOURNAL[status] ?? status;
}

export function processStatusLabelEs(status?: string | null): string {
  if (!status) return '—';
  return PROCESS[status] ?? status;
}

export function periodStatusTone(status?: string | null): string {
  switch (status) {
    case 'OPEN':
      return 'bg-emerald-50 text-emerald-800 border-emerald-200';
    case 'CLOSED':
      return 'bg-slate-100 text-slate-700 border-slate-200';
    case 'LOCKED':
      return 'bg-amber-50 text-amber-900 border-amber-200';
    default:
      return 'bg-rose-50 text-rose-800 border-rose-200';
  }
}

/** Glosario corto para tooltips (no saturar). */
export const ACCOUNTING_GLOSSARY: Record<string, string> = {
  YTD: 'Year to date: acumulado desde el 1 de enero hasta la fecha de corte.',
  Devengamiento: 'Reconocimiento de ingresos o gastos en el período al que corresponden, aunque no se hayan cobrado o pagado.',
  Revaluación: 'Ajuste de saldos en moneda extranjera a la cotización de cierre.',
  'Ajuste por inflación': 'Actualización de cuentas no monetarias por variación del índice de precios.',
  'Centro de costo': 'Dimensión para asignar gastos e ingresos a un área o proyecto.',
  'Período bloqueado': 'Período cerrado de forma definitiva: no admite nuevos asientos ni reapertura rutinaria.',
  MTD: 'Month to date: acumulado del mes corriente hasta la fecha de corte.',
};
